module.exports = __webpack_public_path__ + "static/img/newStock.ef0bbf4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/works/newStock.jpg
// module id = fwmM
// module chunks = 1